@if (pagesCount > 1) {
  <nav role="navigation">
    <ul class="cd-pagination animated-buttons custom-icons">
      <li class="button"><a [ngClass]="{'disabled': !showPrevious }" (click)="onPageChanging(currentPage - 1)"><i
      class="fas fa-arrow-left"></i></a></li>
      @if (showFirstPage) {
        <a (click)="onPageChanging(1)">1</a>
      }
      <input #firstGoToPage [hidden]="!showFirstPage || !showFirstGoToPage" type="string" size="3" minlength="1" maxlength="4"
        (keyup.enter)="goToPage($event)">
        @if (showFirstPage && !showFirstGoToPage) {
          <li>@if (showFirstPage) {
            <a
            (click)="showGoToPageClicked(true,firstGoToPage)">...</a>
          }</li>
        }
        @for (page of displayPages; track page) {
          <li>
            <a [ngClass]="{'current': currentPage == page }" (click)="onPageChanging(page)">{{page}}</a>
          </li>
        }
        <input #lastGoToPage  [hidden]="!showLastPage || !showLastGoToPage" type="string" size="3" minlength="1" maxlength="4"
          (keyup.enter)="goToPage($event)">
          @if (showLastPage && !showLastGoToPage) {
            <li>@if (showLastPage) {
              <a (click)="showGoToPageClicked(false,lastGoToPage)">...</a>
            }</li>
          }
          @if (showLastPage) {
            <a (click)="onPageChanging(pagesCount)">{{pagesCount}}</a>
          }
          <li class="button"><a [ngClass]="{'disabled': !showNext }" (click)="onPageChanging(currentPage + 1)"><i
          class="fas fa-arrow-right"></i></a></li>
        </ul>
      </nav>
      } <!-- cd-pagination-wrapper -->